<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="mt-3 pa-3">
          <v-card-title>
            <v-text-field v-model="search" color="#8cc63e" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" key="index" :items="data_list" :items-per-page="perPage" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.name }}</td>
                <td>{{ dataDetail.item.tel }}</td>
                <td>{{ dataDetail.item.address }} {{ dataDetail.item.district_amphoe_province }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      search: '',
      perPage: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        // {
        //   text: 'รหัสลูกค้า',
        //   value: '',
        //   fixed: true,
        //   width: '150px',
        // },
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อลูกค้า',
          value: 'name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'เบอร์โทร',
          value: 'tel',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ที่อยู่',
          value: 'address',
          fixed: true,
          width: '450px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      HTTP.post('/customers/customersecom')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>
<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
